<template>
  <article :class="{ desktop: $isDesktop }">
    <ul class="campsite-faq hide-when-filters-open">
      <li v-for="(value, index) in faqList" :key="index">
        <div v-thtml="value.question" class="question" />
        <div v-thtml="value.answer" class="answer" />
      </li>
    </ul>
    <nuxt-to-meta :nuxt2meta="head" />
  </article>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { SearchFAQ } from '../schemas'

@Component({})
class SearchResultsFaq extends Vue {
  @Prop({ required: true })
  faqList: SearchFAQ[]

  get head() {
    return {
      script: [
        {
          type: 'application/ld+json',
          body: true,
          json: {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: this.faqList.map((faq) => {
              return {
                '@type': 'Question',
                name: faq.question,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: faq.answer,
                },
              }
            }),
          },
        },
      ],
    }
  }
}

export default toNative(SearchResultsFaq)
</script>
<style scoped>
article {
  color: var(--colour-dark-blue);
  font-size: var(--body);
  padding: 1em 1.4em;
  width: 100%;
  border-bottom: 4px solid var(--colour-page-background);
}

.question {
  font-weight: bold;
  font-size: 1.15em;
}

.question,
.answer {
  margin-top: 0.25em;
}

a {
  color: var(--colour-dark-blue);
}

li {
  margin: 0 0 1.75em;
}

.answer :deep(ul) {
  margin: 0 0 0.5em;
}

.answer :deep(li) {
  margin: 0 0 0.25em;
}

.answer :deep(li a),
.answer :deep(li a:active),
.answer :deep(li a:visited) {
  display: inline-block;
  font-weight: normal;
  color: var(--colour-dark-blue);
}

.answer :deep(a),
.answer :deep(a:active),
.answer :deep(a:visited) {
  font-weight: bold;
  text-decoration: underline;
  margin-top: 0.25em;
  display: block;
  color: var(--colour-dark-blue);
}

/* desktop & tablet */
article.desktop {
  padding: 1em 1.4em 1em var(--page-width-padding);
}
</style>
